import React from "react";
import styled from 'styled-components';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import ClaroImage from '../../../molecules/ClaroImage'
import ClaroInputField from "../../../atoms/ClaroInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import SearsInputField from "../../../atoms/SearsInputField";
import { validationStyles } from '../utils/index'
import { servicesIdTAE } from "../../../../constants";

const Container = styled.div`
    width: 100%%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: ${props => props.margin ? props.margin : "2%"};
`;

const InputContainer = styled.div`
    border: ${props => props.valid ? '1px solid #c4c4c4' : '1px solid #d92c27'};
    margin: 0% 0% 0% 0%;
    border-radius : 5px;
    background: #fff;
    width: 100%
        &:hover {
        ${props => props.valid ? '1px solid black' : '1px solid #d92c27'};
    }
`;

class CvvInputClaroSocio extends React.Component {

    constructor(props, context){
        super(props, context)
        this.state = {
            isFocused: false,
        }
    }

    componentDidMount() {
        //console.log(this.props.input.field.input, "en el defaultinput" );
    }
    
    render(){
        let  validation = validationStyles(this.props.isValid,this.props.isContainerTelcel, this.props.isClaroPartner);
        const styles = {
            "color": validation.validInvalidColor,
            "borderBottom": this.props.isContainerTelcel && this.state.isFocused && this.props.isValid && !this.props.serviceTA ? "1px solid #0071d1" : validation.borderValidInvalidColor,
        }
        
        let id = "pagoDeServicios_" + this.props.input.id + "_" + this.props.serviceName;
        let readonly = (this.props.input.field.input.disabled)?true:false;
        let displayStyle = (this.props.visible)?"block":"none";
        const claroSociosHelpImgDisplay = this.props.isClaroPartner && servicesIdTAE.includes(this.props.serviceId) ? 'inline' : 'none';
    
        return(
            <Container 
                style={{display:displayStyle}} 
                background={this.props.isContainerTelcel && !this.props.isClaroPartner ? "#fff" : undefined}
                margin={this.props.isContainerTelcel && !this.props.isClaroPartner ? "2% 2% 15px 2%" : undefined}>
                <InputTitleClaroSocio 
                    {...this.props.input.title} 
                    type={this.props.input.type} 
                    handleClickTooltip = {this.props.handleClickTooltip} 
                    isClaroPartner={this.props.isClaroPartner}
                    logicType={this.props.logicType}
                    serviceId={this.props.serviceId}
                    isContainerTelcel={this.props.isContainerTelcel}
                    isFocused={this.state.isFocused}
                    serviceTA={this.props.serviceTA}
                />
                <ClaroDiv  {...styles}>
                    {
                        (this.props.logicType == "sears")?

                        <InputContainer valid= {this.props.isValid}>
                            <ClaroInputField 
                                borderBottom={"hidden"}
                                border={"none"}
                                height={"3em"}
                                width={"88%"}
                                padding= {"0px 0px 0px 5px"}
                                phColor={"#c4c4c4"}
                                value={this.props.value} 
                                onChange={(e) =>{this.props.handleInputChange(e, this.props.input.type)}}
                                name={this.props.input.field.input.name}
                                placeholder={this.props.input.field.input.placeholder}
                                id = {id}
                                type={this.props.input.field.input.type}
                                onClick={this.props.handleClickScroll}
                            />
                            <span onClick={(e) => this.props.handleClickTooltip(e, "cvv")}>
                                <img src={"./images/signoDeInterrogaciN.svg"}  style={{verticalAlign:"middle"}}/>
                            </span>
                        </InputContainer>

                            
                            :
                            <>
                                <ClaroInputField 
                                    {...styles} 
                                    value={this.props.value} 
                                    onChange={(e) =>{this.props.handleInputChange(e, this.props.input.type)}}
                                    name={this.props.input.field.input.name}
                                    placeholder={this.props.input.field.input.placeholder}
                                    id = {id}
                                    type={this.props.input.field.input.type}
                                    readOnly={readonly}
                                    onBlur={()=>this.setState({isFocused: false})}
                                    onFocus={()=>{this.props.handleClickScroll,this.setState({isFocused: true})}}
                                    phColor= {this.props.isContainerTelcel && !this.props.isClaroPartner ? "#757575" : "#c4c4c4"}
                                    fontFamily = {this.props.isContainerTelcel && !this.props.isClaroPartner ? "AMX-Regular" : undefined}
                                    fontSize = {this.props.isContainerTelcel && !this.props.isClaroPartner ? "14px" : undefined}
                                />
                                <span 
                                    onClick={(e) => this.props.handleClickTooltip(e, "cvv")} 
                                    style={{ float: 'right', position: 'absolute', right: '0px', width: '1.2em', display: claroSociosHelpImgDisplay }}>
                                    <img src={`${process.env.REACT_APP_IMAGES}help_reference_claro_socio.png`} />
                                </span>
                            </>
                            
                            
                    }
                    { 
                    
                        this.props.input.field.button ? (
                            <ClaroInputButton 
                                borderBottom={validation.borderValidInvalidColor} 
                                {...this.props.input.field.button}
                                onClick= {(e) =>{this.props.handleInputButtonFunction(e, this.props.input.type)}}
                            >
                                <ClaroImage {...this.props.input.field.button} isClaroPartner={this.props.isClaroPartner}/>
                            </ClaroInputButton>
                        ):(<></>)
                    }
                </ClaroDiv>
                <InputSubTitleClaroSocio {...this.props.input.subTitle} type={this.props.input.type} />
            </Container>
        )
    }
}

export default CvvInputClaroSocio;